import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import PopupContent from '../../../../components/Popup/PopupContent';
var menuButtonStyles = {
  root: function root() {
    return {
      boxSizing: 'border-box',
      display: 'inline-block'
    };
  },
  popupContent: function popupContent() {
    var _ref;

    return _ref = {}, _defineProperty(_ref, "& .".concat(PopupContent.slotClassNames.content), {
      padding: '0px'
    }), _defineProperty(_ref, "borderWidth", '0px'), _ref;
  }
};
export default menuButtonStyles;